// EO-1893 — email deep link to one Action Center recommendation:
//   <portal origin>/?recommendationId=<id>
// The id alone is enough: the backend resolves it to its property. Part of the
// URL contract once emails go out, so do not rename the param.
export const RECOMMENDATION_QUERY_PARAM = "recommendationId";

// Where an unknown id, or one for a hotel the user cannot access, lands.
export const UNAUTHORIZED_PATH = "/unauthorized";
